var render = function (_h,_vm) {
var _obj;
var _c=_vm._c;return _c('v-tooltip',_vm._b({staticClass:"c-base-tooltip",attrs:{"open-delay":_vm.props.openDelay,"z-index":"200","disabled":_vm.props.disabled},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_vm._t("default",null,null,{ on: on, attrs: attrs })]}}],null,true)},'v-tooltip',( _obj = {}, _obj[_vm.props.position] = true, _obj ),false),[_c('p',{staticClass:"c-base-tooltip__content"},[_vm._v(_vm._s(_vm.props.content))]),(_vm.props.extra)?_c('p',{staticClass:"c-base-tooltip__content"},[_vm._v(_vm._s(_vm.props.extra))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }